module.exports = __webpack_public_path__ + "static/media/syn-apple-touch-icon.3a174250.png";